var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6A2886",
    d: "M6.982,2.458l2.559,2.559c0.107,0.107,0.107,0.284,0,0.391l-6.196,6.196l-2.632,0.291 c-0.351,0.04-0.649-0.256-0.608-0.609l0.291-2.632L6.59,2.458C6.699,2.352,6.875,2.352,6.982,2.458z M11.576,1.809l-1.383-1.384 c-0.43-0.432-1.133-0.432-1.566,0L7.623,1.429c-0.107,0.108-0.107,0.283,0,0.391l2.557,2.56c0.109,0.106,0.285,0.106,0.395,0 l1.002-1.005C12.008,2.94,12.008,2.24,11.576,1.809z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6A2886",
    d: "M23.938,19.999h-1.875c-0.312,0-0.563-0.251-0.563-0.563v-3.938h-2.056c-0.417,0-0.626-0.504-0.33-0.8 l3.564-3.566c0.176-0.176,0.464-0.176,0.64,0l3.567,3.566c0.296,0.296,0.087,0.8-0.33,0.8H24.5v3.938 C24.5,19.748,24.249,19.999,23.938,19.999z M29,19.812v2.625c0,0.312-0.251,0.563-0.563,0.563H17.563 c-0.312,0-0.563-0.251-0.563-0.563v-2.625c0-0.312,0.251-0.563,0.563-0.563h3.188v0.188c0,0.724,0.588,1.313,1.313,1.313h1.875 c0.725,0,1.313-0.589,1.313-1.313v-0.188h3.188C28.749,19.249,29,19.5,29,19.812z M26.094,21.874c0-0.258-0.211-0.469-0.469-0.469 s-0.469,0.211-0.469,0.469s0.211,0.469,0.469,0.469S26.094,22.132,26.094,21.874z M27.594,21.874c0-0.258-0.211-0.469-0.469-0.469 s-0.469,0.211-0.469,0.469s0.211,0.469,0.469,0.469S27.594,22.132,27.594,21.874z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSolid);
export default __webpack_public_path__ + "static/media/edit-solid.2d9974fb20a7755a3dd0b127f78bbd1f.svg";
export { ForwardRef as ReactComponent };